module.exports = __webpack_public_path__ + "img/166.c2f394c7.jpg";